import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import clsx from 'clsx';

import CustomerRegions from "../../../pages/accessRights/customerRegions/customerRegions";
import CircleLoader from "../../../components/custom/circleLoader/circleLoader";
import SectionContent from "../../../components/sectionContent/sectionContent";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import { IUserOptions } from "../../../types/interfaces";

const AdminClientsInfoSection = () => {
  const { id } = useParams<{ id: string }>();
  const { clientRegionsLength, customers } = useSelector(
    (state: any) => state.roles.customerList
  );
  const { isOpenSidebar } = useSelector((state: IUserOptions) => state.user.user);

  const actualClientName =
    customers &&
    customers.find(
      (elem: {
        contracts: string[];
        customer: { id: number, name: string }
        email: string;
        password: string;
      }) => elem?.customer?.id === parseFloat(id as string)
    )?.customer?.name;

  return (
    <div className="App">
      <Sidebar />
      <SectionContent
        title={actualClientName && actualClientName}
        pageName="clientSettings"
        section="Клиенты"
        tail="Регионы"
      >
        <div className="content__main">
          <div className={clsx(
						isOpenSidebar &&
						"btns_active",
						!isOpenSidebar && "btns_close",
						'btns'
					)}>
            <Link to={`/accessRights/customers/info/${id}`} className="tab">
              <div className="buttons__btn">Контракты</div>
            </Link>
            <Link to={`/accessRights/customers/settings/${id}`} className="tab">
              <div className="buttons__btn">Настройки</div>
            </Link>
            <Link to={`/accessRights/customers/regions/${id}`} className="tab">
              <div className="buttons__btn --active">
                Регионы
                <div className="tab__reports_count">
                  {!clientRegionsLength && clientRegionsLength !== 0 ? (
                    <CircleLoader />
                  ) : (
                    clientRegionsLength
                  )}
                </div>
              </div>
            </Link>
          </div>
          <CustomerRegions />
        </div>
      </SectionContent>
    </div>
  );
};

export default AdminClientsInfoSection;
